// Buy 3 Get 1 Free — every Retatrutide strength (see B3G1_SKUS).
// Mix-and-match: every 4 qualifying vials, the cheapest is free.
// Mirrors the server-side computation in create_order (server.py).
import { useEffect, useState } from "react";
import api from "./api";
export const B3G1_SKUS = ["PL-RET-10", "PL-RET-20", "PL-RET-30", "PL-RET-40", "PL-RET-50", "PL-RET-60"];
export const B3G1_LABEL = "Buy 3 Get 1 Free — Retatrutide";

// Strengths currently buyable (visible + in stock) — drives the "mix & match 20 mg, 30 mg…" copy.
export function useB3G1Strengths() {
  const [strengths, setStrengths] = useState([]);
  useEffect(() => {
    let alive = true;
    api.get("/products").then((r) => {
      if (!alive) return;
      const live = (r.data || [])
        .filter((p) => B3G1_SKUS.includes(p.sku) && (p.stock_quantity ?? 0) > 0)
        .sort((a, b) => (parseFloat(a.strength) || 0) - (parseFloat(b.strength) || 0))
        .map((p) => (p.strength || "").replace(/\s+/g, "\u00a0"));
      setStrengths(live);
    }).catch(() => alive && setStrengths([]));
    return () => { alive = false; };
  }, []);
  return strengths;
}

export function joinStrengths(list, sep = ", ", last = " & ") {
  if (!list.length) return "";
  if (list.length === 1) return list[0];
  return `${list.slice(0, -1).join(sep)}${last}${list[list.length - 1]}`;
}

export function retaPromo(items) {
  const units = [];
  (items || []).forEach((i) => {
    if (B3G1_SKUS.includes(i.sku)) {
      for (let k = 0; k < i.quantity; k++) units.push(i.price);
    }
  });
  units.sort((a, b) => a - b);
  const freeCount = Math.floor(units.length / 4);
  const discount = freeCount
    ? Math.round(units.slice(0, freeCount).reduce((s, p) => s + p, 0) * 100) / 100
    : 0;
  return { units: units.length, freeCount, discount, remainder: units.length % 4 };
}
